import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { GasInputBoolean } from '@cikrf/gas-utils/decorators';

@Component({
  selector: 'gas-navigation-element',
  templateUrl: './gas-navigation-element.component.html',
  styleUrls: ['./gas-navigation-element.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasNavigationElementComponent {
  @GasInputBoolean()
  @HostBinding('class._wide')
  @Input()
  public wide: string | boolean = false;

  @GasInputBoolean()
  @Input()
  public hasChild: string | boolean = false;

  @GasInputBoolean()
  @Input()
  public isChild: string | boolean = false;

  @GasInputBoolean()
  @Input()
  public expanded: string | boolean = false;

  @GasInputBoolean()
  @HostBinding('class._active')
  @Input()
  public active: string | boolean = false;

  @GasInputBoolean()
  @HostBinding('class._burger')
  @Input()
  public burger: string | boolean = false;

  @Input()
  public icon: string;

  @Input()
  public title: string;

  @Output('expanded')
  public expanded$ = new EventEmitter();
}
